import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const introConfig: PageConfig[] = [
  {
    name: "overview1",
    title: "Rangitāne Rangatahi Wānanga",
    elements: [
      {
        type: "html",
        html: `
<p>
  <table>
    <tbody>
      <tr>
        <td><strong>Date:</strong></td>
        <td>Saturday, 14 March to Tuesday, 17 March 2026</td>
      </tr>
      <tr>
        <td><strong>Where:</strong></td>
        <td>Wairau</td>
      </tr>
    </tbody>
  </table>
</p>
<p>
  This four-day wānanga will be held from Saturday 14 to Tuesday 17 March 2026.
</p>
<p>
  The wānanga will be like the previous year’s and will be held in Wairau,
  nurturing our rangatahi in the local pūrākau they already know and building on
  this.
</p>
<p>
  Across the four days, we will stay at Ūkaipō, visit sites like Te Pokohiwi o
  Kupe, Tōtaranui and Kapara Te Hau, and enjoy a range of fun activities.
</p>
      `,
      },
    ],
  },
  {
    name: "overview2",
    title: "Rangitāne Rangatahi Wānanga",
    elements: [
      {
        type: "html",
        html: `
<p>
  Our focus on this trip is to enhance our knowledge and connection to our
  whenua and build on the kōrero our rangatahi are already familiar with. They
  will learn karakia, pepeha and explore their whakapapa. They will also expand
  their knowledge on the hunter/gatherer skills of Rangitāne tūpuna.
</p>
<p>
  Due to anticipated high interest in this wānanga, we are running an expression
  of interest process rather than a direct registration.
</p>
<p>
  We have capacity for 30 rangatahi, so spaces are limited. If your rangatahi is
  interested in attending, please complete the expression of interest form below.
</p>
<p>
  We welcome expressions of interest from rangatahi aged 11–17 years.
</p>
<p>
  All expressions of interest must be submitted no later than 12:00pm, Monday 2
  March 2026.
</p>
<p>
  Registration closes Monday, 2 March 2026.
</p>
      `,
      },
    ],
  },
  {
    name: "commitment",
    title: "Rangitāne Rangatahi Wānanga",
    elements: [
      {
        type: "html",
        html: `
<p>
  <ul>
    <li>
      As this wānanga requires your rangatahi to be absent from school for two
      days, a letter of support can be provided to their kura should their
      Expression of Interest be accepted.
    </li>
    <li>
      Rangatahi are expected to be in Wairau at the commencement of the wānanga.
    </li>
    <li>
      Rangatahi must be available to attend the full duration of the wānanga.
      Early departures will not be permitted unless in the case of an emergency.
    </li>
    <li>
      We are unable to provide travel subsidies, airport or ferry pick‑ups.
    </li>
    <li>
      Rangatahi must be dropped off and collected from the wānanga by a parent
      or caregiver.
    </li>
    <li>
      Late registrations will not be accepted under any circumstances.
    </li>
  </ul>
</p>
      `,
      },
    ],
  },
];
